import React from 'react';
import ReactDOM from 'react-dom';
import { nanoid } from 'nanoid';
import { Plugin } from 'prosemirror-state';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { removeMenuContainer } from '../../utils';
import { LinkMenuComponent } from './LinkMenu';
import { hideLinkMenu, linkMenuKey } from './utils';

const eventHandling = (view: any) => {
  hideLinkMenu(view);
  return false;
};

const LINK_MENU_CONTAINER_ID = 'link-menu-container';

export default class BlockMenu extends BaseExtension {
  get type(): string {
    return extensionType.toolbar;
  }

  get name(): string {
    return 'link_menu';
  }

  plugins({ portalApi }: EditorOptions) {
    return [
      new Plugin({
        key: linkMenuKey,
        state: {
          init() {
            return {
              open: false,
              url: null,
            };
          },
          apply(tr, old) {
            const props = tr.getMeta(linkMenuKey);
            return props || old;
          },
        },
        view: (editorView) => {
          // This will be called only once. It will add a container div.
          // Link Menu will be rendered in this container div.
          let linkMenuButtonContainer = document.createElement('div');
          linkMenuButtonContainer.id = LINK_MENU_CONTAINER_ID;
          editorView?.dom?.parentNode?.appendChild(linkMenuButtonContainer);

          const portalKey = nanoid();
          // Need to return the following functions in the view function
          return {
            update: (view) => {
              const state = view.state;
              let props = linkMenuKey.getState(state);
              props.view = view;
              const dom = editorView?.dom?.parentNode?.querySelector(`#${LINK_MENU_CONTAINER_ID}`);
              if (dom) {
                portalApi.createPortal(
                  ReactDOM.createPortal(<LinkMenuComponent {...props} />, dom, portalKey),
                );
              }
            },
            destroy: () => {
              portalApi.destroyPortal(portalKey);
              removeMenuContainer(LINK_MENU_CONTAINER_ID, editorView);
            },
          };
        },

        props: {
          handleDOMEvents: {
            mousedown: eventHandling,
            keydown: eventHandling,
            focus: eventHandling,
          },
        },
      }),
    ];
  }
}
